module.exports = __webpack_public_path__ + "img/puberty-decal-18.63573507.png";